import React from 'react';

export default () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
    <path d="M83.3 33.3H75V25C75 11.2 63.8 0 50 0S25 11.2 25 25v8.3h-8.3c-4.6 0-8.3 3.7-8.3 8.3v50c0 4.6 3.7 8.3 8.3 8.3h66.7c4.6 0 8.3-3.7 8.3-8.3v-50c0-4.5-3.8-8.3-8.4-8.3zM50 79.2c-6.9 0-12.5-5.6-12.5-12.5S43.1 54.2 50 54.2s12.5 5.6 12.5 12.5S56.9 79.2 50 79.2zm16.7-45.9H33.3V25c0-9.2 7.5-16.7 16.7-16.7S66.7 15.8 66.7 25v8.3z" />
  </svg>
);
